export class UrlHelper {
    public static getPageIdentifier(): string {
        let path = window.location.pathname;
        // Normalize: remove leading/trailing slashes
        path = path.replace(/^\/+|\/+$/g, "");
        path = path.toLowerCase();
        return path;
    }
}